import React, { useEffect, useState, useContext } from "react";
import { ConfigContext } from '../../DynamicForm/DynamicForm';
import Markdown from 'markdown-to-jsx';
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader';
import ChipSet from '../../../../components/Chip/Chip';
// import CheckField from '../../../../components/CheckField/CheckField'
import CheckField from '../../../../components/CheckField2/CheckField';
import RadioField from '../../../../components/RadioField2/RadioField';
import ErrorBar from '../../../../components/ErrorBar';
import './styles.scss';
import { CheckLanguage } from "../../../../languages/languages";
import { GetLanguageText } from "../../../../languages/languages";

const DisclosureOfSensitiveInformation = () => {

    const context = useContext(ConfigContext);
    const { formik, dbFormSpec } = context;
    const languageID = CheckLanguage(dbFormSpec);
    if (dbFormSpec.CustomFooterText) {

        return <div className='sensitiveInfoSection form-section' id='sensitiveInfo'>
            {/* {formik.errors.sensitiveInfo && formik.touched.sensitiveInfo && <ErrorBar message={formik.errors.sensitiveInfo} />} */}
            {dbFormSpec.CustomFooterText}</div>
    }


    if (languageID != "default") {
        const languageText = GetLanguageText(languageID);


        return (
            // !config.page.form.sections.disclosureOfSensitiveInformation.active ?
            <div className='sensitiveInfoSection form-section' id='sensitiveInfo'>
                {/* <SectionHeader sectionTitle={'Exclusion of Sensitive Information'} styles={{color: dbFormSpec.color}}/> */}
                {/* {formik.errors.sensitiveInfo && formik.touched.sensitiveInfo && <ErrorBar message={formik.errors.sensitiveInfo} />} */}
                {languageText.deliveryMethod.understandInfo}
            </div>
        );

    } else {

        return (
            <div className='sensitiveInfoSection form-section' id='sensitiveInfo'>
                {/* {formik.errors.sensitiveInfo && formik.touched.sensitiveInfo && <ErrorBar message={formik.errors.sensitiveInfo} />} */}
                {'I understand that the specified information to be released may include, but is not limited to, history, diagnoses and/or treatment of drug or alcohol abuse, mental illness or communicable disease including Human Immunodeficiency Virus (HIV) and Acquired Immune Deficiency Syndrome (AIDS).'}</div>
        );
    }
};

export default DisclosureOfSensitiveInformation;